import { MainAppResource } from './base';

export default function VisnetHubFaultElectricalDataImpedance({ externalVisnetHubId }) {
  return MainAppResource(
    `api/v3/visnet_hubs/${externalVisnetHubId}/fault_events/last_impedance{code}`
  );
}
